<mat-form-field
    subscriptSizing="dynamic"
    class="st-grid-search__form-field"
    [class.st-grid-search__form-field--hidden]="!isSearchActive()">
    <input
        class="st-grid-search__input"
        matInput
        [placeholder]="languageSettings().PSTWebSearchPlaceholder"
        [(ngModel)]="searchTerm"
        (keyup.enter)="executeSearch.emit()"
        (keyup.arrowdown)="navigateToNextMatch()"
        (keyup.arrowup)="navigateToPreviousMatch()"
        (ngModelChange)="searchChanged()" />

    <button
        matSuffix
        mat-icon-button
        class="st-grid-search__button"
        (click)="navigateToPreviousMatch()">
        <mat-icon fontSet="material-symbols-outlined">keyboard_arrow_up</mat-icon>
    </button>
    <button
        matSuffix
        mat-icon-button
        class="st-grid-search__button"
        (click)="navigateToNextMatch()">
        <mat-icon fontSet="material-symbols-outlined">keyboard_arrow_down</mat-icon>
    </button>
</mat-form-field>
